import SalesStats from './SalesStats';
import ExpensesStats from './ExpensesStats';
import StatsView from './StatsView';

export default StatsView;
export { SalesStats, ExpensesStats };
